import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./subNav.css";

export function SubNav({ i18n }) {

    const location = useLocation();

    const currentPath = location.pathname;

    const navLinkItems = [
        { title: i18n.About, link: i18n.SubNav_About_Link },
        { title: i18n.Cumulative_Fire_Impacts, link: i18n.SubNav_Summary_Link },
        { title: i18n.Your_Fire_Impacts, link: i18n.SubNav_Details_Link },
    ];

    return (
        <div className="sub-nav-panel">
            {navLinkItems.map((item) => (
                <Link
                    key={item.link}
                    className={`sub-nav-link ${currentPath === item.link ? "active" : ""}`}
                    to={{
                        pathname: item.link,
                        search: location.search
                    }}
                >
                    {item.title}
                </Link>
            ))}
        </div>
    );
}